import { createRoot } from "react-dom/client";
import App from "./App.tsx";

/* Importa CSS global de Ionic */
import "@ionic/react/css/core.css";
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";
import "@ionic/react/css/padding.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css";

import { IonApp } from "@ionic/react";
import "./index.css";

createRoot(document.getElementById("root")!).render(
  <IonApp>
    <App />
  </IonApp>
);
